import { Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../../components/DraggableModal";
import { EntEconomicActivityTypes } from "../../../../../models/handBooks/economicActivityTypes";

enum TypeField {
    alias,
    nameRu,
    nameKy,
}

interface IProps {
    show: boolean;
    economicActivityType: EntEconomicActivityTypes;
    onHide: () => void;
    onSubmit: (pos: EntEconomicActivityTypes) => Promise<boolean>;
}

export const AddEconomicActivityTypesModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);

    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: TypeField.alias, value: props.economicActivityType.alias },
            { name: TypeField.nameKy, value: props.economicActivityType.nameKy },
            { name: TypeField.nameRu, value: props.economicActivityType.nameRu },
        ]);
    }

    const setEntityFromFields = (): EntEconomicActivityTypes => {
        let res = _.cloneDeep(props.economicActivityType);
        res.alias = form.getFieldValue(TypeField.alias);
        res.nameKy = form.getFieldValue(TypeField.nameKy);
        res.nameRu = form.getFieldValue(TypeField.nameRu);
        return res;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
           
            const result = await props.onSubmit(data);

            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <DraggableModal
                title={ props.economicActivityType.id === null ? t('mechanisation.directory_economic_activities.add_directory_economic_activities') : t('mechanisation.directory_economic_activities.edit_directory_economic_activities') }
                visible={ props.show }
                onCancel={ props.onHide }
                onSubmit={ handleSubmit }
                submitLoading={ loading }
            >
                <Form
                    initialValues={ { remember: true } }
                    autoComplete="off"
                    layout="vertical"
                    form={ form }
                >
                    <Form.Item
                        label={ t('general.code') }
                        name={ TypeField.alias }
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <Input autoComplete="off"/>
                    </Form.Item>
                    <Form.Item
                        label={ t('general.nameKy') }
                        name={ TypeField.nameKy }
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <Input autoComplete="off"/>
                    </Form.Item>
                    <Form.Item
                        label={ t('general.nameRu') }
                        name={ TypeField.nameRu }
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <Input autoComplete="off"/>
                    </Form.Item>
                </Form>
            </DraggableModal>
        </>
    )
}
